import React from 'react';
import { Mail, Phone, Clock, MessageSquare, Wrench, CreditCard, Star } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const InfoCard = ({ icon: Icon, title, children, accent }) => (
  <div
    className="p-5 rounded-2xl"
    style={{ background: '#ffffff', border: '1px solid rgba(27,58,92,0.1)', boxShadow: '0 2px 12px rgba(27,58,92,0.05)' }}
  >
    <div className="flex items-center gap-3 mb-3">
      <div
        className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
        style={{ background: accent ? 'rgba(232,115,42,0.12)' : 'rgba(27,58,92,0.07)' }}
      >
        <Icon size={17} style={{ color: accent ? '#E8732A' : '#1B3A5C' }} />
      </div>
      <h3 className="font-semibold text-sm" style={{ color: '#0D2137' }}>{title}</h3>
    </div>
    {children}
  </div>
);

const ContactInfo = () => (
  <div className="flex flex-col gap-5">
    {/* Direct Contact */}
    <div
      className="p-6 rounded-2xl"
      style={{ background: 'linear-gradient(135deg, #0D2137 0%, #1B3A5C 100%)', boxShadow: '0 8px 32px rgba(13,33,55,0.2)' }}
    >
      <h2 className="text-base font-bold text-white mb-4">Direct Contact</h2>
      <div className="space-y-4">
        <a
          href="mailto:support@aduflow.net"
          className="flex items-center gap-3 group"
        >
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors"
            style={{ background: 'rgba(232,115,42,0.2)' }}
          >
            <Mail size={16} style={{ color: '#E8732A' }} />
          </div>
          <div>
            <p className="text-xs mb-0.5" style={{ color: 'rgba(255,255,255,0.5)' }}>Email Support</p>
            <p
              className="text-sm font-semibold transition-colors group-hover:text-orange-400"
              style={{ color: '#ffffff' }}
            >
              support@aduflow.net
            </p>
          </div>
        </a>
        <a
          href="tel:+18019480975"
          className="flex items-center gap-3 group"
        >
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ background: 'rgba(232,115,42,0.2)' }}
          >
            <Phone size={16} style={{ color: '#E8732A' }} />
          </div>
          <div>
            <p className="text-xs mb-0.5" style={{ color: 'rgba(255,255,255,0.5)' }}>Phone Support</p>
            <p
              className="text-sm font-semibold transition-colors group-hover:text-orange-400"
              style={{ color: '#ffffff' }}
            >
              (801) 948-0975
            </p>
          </div>
        </a>
      </div>
    </div>

    {/* Business Hours */}
    <InfoCard icon={Clock} title="Business Hours">
      <div className="space-y-2">
        {[
          { day: 'Mon – Fri', hours: '8:00 AM – 6:00 PM PT' },
          { day: 'Saturday', hours: '9:00 AM – 2:00 PM PT' },
          { day: 'Sunday', hours: 'Closed' },
        ]?.map(({ day, hours }) => (
          <div key={day} className="flex justify-between items-center">
            <span className="text-xs font-medium" style={{ color: '#4A6080' }}>{day}</span>
            <span className="text-xs font-semibold" style={{ color: hours === 'Closed' ? '#C62828' : '#0D2137' }}>{hours}</span>
          </div>
        ))}
      </div>
      <div
        className="mt-3 px-3 py-2 rounded-lg text-xs"
        style={{ background: 'rgba(232,115,42,0.08)', color: '#E8732A', fontWeight: '500' }}
      >
        ⚡ Typical email response: within 1 business day
      </div>
    </InfoCard>

    {/* Inquiry Guide */}
    <InfoCard icon={MessageSquare} title="What to Include">
      <div className="space-y-2.5">
        {[
          { icon: Wrench, label: 'Technical Support', hint: 'Include your browser, OS, and steps to reproduce the issue.' },
          { icon: CreditCard, label: 'Billing', hint: 'Reference your account email and subscription plan.' },
          { icon: Star, label: 'Feedback', hint: 'Tell us what you love or what we can improve.' },
        ]?.map(({ icon: ItemIcon, label, hint }) => (
          <div key={label} className="flex gap-2.5">
            <ItemIcon size={14} style={{ color: '#E8732A', flexShrink: 0, marginTop: '2px' }} />
            <div>
              <p className="text-xs font-semibold" style={{ color: '#0D2137' }}>{label}</p>
              <p className="text-xs" style={{ color: '#4A6080', lineHeight: '1.5' }}>{hint}</p>
            </div>
          </div>
        ))}
      </div>
    </InfoCard>
  </div>
);

export default ContactInfo;
